import React from "react"

/**
 * `Icon` hands every DS glyph its colour as `fill`, but this one is drawn in strokes: left in
 * the spread it would land on the <svg>'s own `fill="none"` and flood the figures solid. Taking
 * it as the stroke keeps the outline the design asks for.
 */
export const Users = ({ height = 20, width = 20, stroke = "#525455", fill, ...props }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4569_98298)">
      <path d="M14.1663 17.5V15.8333C14.1663 14.9493 13.8152 14.1014 13.19 13.4763C12.5649 12.8512 11.7171 12.5 10.833 12.5H4.16634C3.28229 12.5 2.43444 12.8512 1.80932 13.4763C1.1842 14.1014 0.833008 14.9493 0.833008 15.8333V17.5" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.50033 9.16667C9.34127 9.16667 10.8337 7.67428 10.8337 5.83333C10.8337 3.99238 9.34127 2.5 7.50033 2.5C5.65938 2.5 4.16699 3.99238 4.16699 5.83333C4.16699 7.67428 5.65938 9.16667 7.50033 9.16667Z" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.167 17.5007V15.834C19.1664 15.0954 18.9206 14.378 18.4681 13.7943C18.0156 13.2106 17.3821 12.7936 16.667 12.609" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.333 2.60901C14.05 2.79259 14.6855 3.20959 15.1394 3.79427C15.5932 4.37894 15.8395 5.09803 15.8395 5.83818C15.8395 6.57832 15.5932 7.29741 15.1394 7.88208C14.6855 8.46676 14.05 8.88376 13.333 9.06734" stroke={fill || stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4569_98298">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
